export default __webpack_public_path__ + "7ad903bc6f818f3a35c42cfd6ebf1461.svg";